/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Guide_Created_By_LabelInputs */



/**
* | output |
* | --- |
* | "Created By:" |
*
* @param {Knp_Guide_Created_By_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_created_by_label = /** @type {((inputs?: Knp_Guide_Created_By_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Created_By_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créé par :")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellt von:")
	if (locale === "it") return /** @type {LocalizedString} */ ("Creato da:")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создано:")
	if (locale === "es") return /** @type {LocalizedString} */ ("Creado por:")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建者：")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作成者:")
	if (locale === "hi") return /** @type {LocalizedString} */ ("के द्वारा बनाई गई:")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criado por:")
	return /** @type {LocalizedString} */ ("Created By:")
});